// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__39HxQ","range":"MonthRangeSwitch_range__1hsFh","disabled":"MonthRangeSwitch_disabled__12nsB"};